<template>
  <div class="container">
    <home-footer-img
      :imgurl=appcode
      text="扫描下载APP"></home-footer-img>
    <home-footer-img
      :imgurl=wechat
      text="扫描关注公众号"></home-footer-img>
  </div>
</template>

<script>
  import HomeFooterImg from './HomeFooterImg.vue'
  export default {
    name: 'homeFooterRight',
    components: {
      HomeFooterImg
    },
    data () {
      return {
        wechat: '/static/img/footer/wechat.png',
        appcode: '/static/img/footer/appcode.png'
      }
    }
  }
</script>

<style scoped>
  div.container {
    width: auto;
    height: auto;
    display: flex;
    padding: 0;
    /*border-left: dashed;*/
    /*border-width: 2px;*/
    /*border-color: rgb(121, 121, 121);*/
  }
</style>



// WEBPACK FOOTER //
// HomeFooterRight.vue?5f1d1f20